<template>
  <div class="view-container">
    <div class="app-container text-center">
    <h3>Your account has been created!</h3>
    <span>To activate it, follow the instructions in the email we've sent to you.</span>
</div>

  </div>
</template>
<!-- Scripts -->
<script>
export default {
  name: "Registered",
  components: {
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  }
};
</script>
